@if(followUpDetails(); as data) {
<div class="follow-up-details-part">
	<div class="pt-2">
		<h5>
			<span class="badge bg-secondary-subtle text-black px-3 py-2">
				Status : {{data.closedUTC ? 'Closed' : 'Open'}}
			</span>
		</h5>
	</div>

	<div class="pt-0">
		<table class="table table-borderless mb-4">
			<tbody>
				<tr>
					<th [width]="200">Person:</th>
					<td>
						<span role="button" type="button" class="text-decoration-underline"
							(click)="openPersonDialog(data.personId!)">
							{{data.personName}}
						</span>
						({{data.externalRoleName}})
					</td>
				</tr>
				<tr>
					<th [width]="200">Follow Up Date:</th>
					<td>{{data.dueByUTC}}</td>
				</tr>
			</tbody>
		</table>

		<table class="table table-borderless mb-4">
			<tbody>
				<tr>
					<th [width]="200">Staff Member:</th>
					<td>{{data.staffName}} ({{data.staffRoleName}})</td>
				</tr>
				<tr>
					<th [width]="200">Purpose:</th>
					<td>{{data.purpose}}</td>
				</tr>
			</tbody>
		</table>

		<table class="table table-borderless mb-4">
			<tbody>
				<tr>
					<th [width]="200">Note:</th>
					<td>{{data.note}}</td>
				</tr>
			</tbody>
		</table>

		<table class="table table-borderless mb-4">
			<tbody>
				<tr>
					<th [width]="200">Closed On:</th>
					<td>{{data.closedUTC}}</td>
				</tr>
				<tr>
					<th [width]="200">Closed By:</th>
					<td>{{data.closedByStaffName}}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
}